const UPDATE_CHECK_INTERVAL = 5 * 60 * 1000;

export async function checkServiceWorkerUpdate(
  registration: Pick<ServiceWorkerRegistration, "update">,
): Promise<void> {
  await registration.update().catch(() => undefined);
}

export function watchServiceWorkerUpdates(
  registration: Pick<ServiceWorkerRegistration, "update">,
): () => void {
  const check = () => {
    if (document.visibilityState === "visible" && navigator.onLine) {
      void checkServiceWorkerUpdate(registration);
    }
  };

  check();
  const interval = window.setInterval(check, UPDATE_CHECK_INTERVAL);
  document.addEventListener("visibilitychange", check);
  window.addEventListener("focus", check);
  window.addEventListener("online", check);

  return () => {
    window.clearInterval(interval);
    document.removeEventListener("visibilitychange", check);
    window.removeEventListener("focus", check);
    window.removeEventListener("online", check);
  };
}
